import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';
import { JIRA_BOARD_PROJECT_Name } from 'src/app/constant/constant';
import { RepositoryService } from 'src/app/service/repository.service';

@Component({
  selector: 'app-awsiamuserkeysecret',
  templateUrl: './awsiamuserkeysecret.component.html',
  styleUrls: ['./awsiamuserkeysecret.component.css']
})
export class AwsiamuserkeysecretComponent implements OnInit {
  cloudForm: FormGroup;
  awsAccountName: any = [];
  filteredAWSAccountName: Array<any> = [];
  projectName: string = JIRA_BOARD_PROJECT_Name.AWS;
  summary: string;
  @Input() tabGroup!: MatTabGroup

  constructor(private fb: FormBuilder, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      accountName: ['', [Validators.required]],
      userName: ['', [Validators.required]],
      DesiredPolicyAttachement: ['', [Validators.required]],
      approvedSolutionDesignDocument: ['', [Validators.required, Validators.pattern('https?://.+')]],
      appid: ['', Validators.required],
      bu: ['', Validators.required],
      bc: ['', Validators.required],
      rc: ['', Validators.required],
      billingOwner: ['', Validators.required],
      techOwner: ['', Validators.required]
    });
    this.LoadAllAWSAccount()

    this.cloudForm.get('accountName')!.valueChanges.subscribe(res => {
      this.appSelectAction(res)
    });

  }
  appSelectAction(data: string) {
    try {
      let response = this.awsAccountName.find(res => res.accountName === data);
      if (response) {
        this.cloudForm.controls.appid.setValue(response['id']);
        this.cloudForm.controls.bu.setValue(response['BU']);
        this.cloudForm.controls.bc.setValue(response['BC']);
        this.cloudForm.controls.rc.setValue(response['RC']);
        this.cloudForm.controls.billingOwner.setValue(response['accountOwnerNames']);
        this.cloudForm.controls.techOwner.setValue(response['accountOwnerNames']);
      }
    }
    catch (error) {
      this._toastService.error(error?.message || "An unexpected error occurred.");
    }
  }

  /**Load All AWS Accounts */
  LoadAllAWSAccount() {
    this.spinner.show()
    this.rs.getAWSAccounts("All", "List").subscribe({
      next: (res) => {
        this.awsAccountName = res['Items']
        this.spinner.hide();
        this.filteredAWSAccountName = [...this.awsAccountName];
      },
      error: (error) => {
        this.spinner.hide();
        this._toastService.error(error?.message);
      }
    })
  }
  handleFilteredReturn(filteredData: any) {
    this.filteredAWSAccountName = filteredData
  }
  resetform(): void {
    this.cloudForm?.reset();
  }

  onSubmit(): void {
    this.spinner.show();
    this.summary = `Generate IAM User key and Secret ${this.cloudForm.get('accountName').value} `
    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid")
    ).subscribe({
      next: (res) => {
        this._toastService.success(res['message']);
        this.resetform();
        if (this.tabGroup) { this.tabGroup.selectedIndex = 1 };
        this.spinner.hide();

      },
      error: (error) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();

      }
    });
  }


}
